module.exports = __webpack_public_path__ + "img/ics_o_min_circle_active.3308d7c6.svg";